// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = 7
// module chunks = 3